// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"2348":"chat","2443":"about"}[chunkId] + "." + {"2348":"a1b45d48","2443":"7baffcb7"}[chunkId] + ".css";
};